module.exports = __webpack_public_path__ + "img/Group-Three.cb016be8.svg";